export default `
.tabs .navs .nav {
  display: inline-block;
  padding: var(--oi-tab-nav-padding, 0.3rem 1rem);
  line-height: var(--oi-tab-nav-line-height, 1.1rem);
  font: var(--oi-tab-nav-font, 1.1rem arial, sans-serif);
  color: var(--oi-tab-nav-color);
  cursor: pointer;
  border-top: var(--oi-tab-nav-border-top, none);
  border-right: var(--oi-tab-nav-border-right, none);
  border-bottom: var(--oi-tab-nav-border-bottom, none);
  border-left: var(--oi-tab-nav-border-left, none);
}
.tabs .navs .nav.active {
  border-top: var(--oi-tab-nav-active-border-top, none);
  border-right: var(--oi-tab-nav-active-border-right, none);
  border-bottom: var(--oi-tab-nav-active-border-bottom, 1px solid #0d6efd);
  border-left: var(--oi-tab-nav-active-border-left, none);
  font: var(--oi-tab-nav-active-font, bold 1.1rem arial, sans-serif);
  color: var(--oi-tab-nav-active-color);
}
.tabs .navs .nav:hover {
  border-top: var(--oi-tab-nav-hover-border-top, none);
  border-right: var(--oi-tab-nav-hover-border-right, none);
  border-bottom: var(--oi-tab-nav-hover-border-bottom, 1px solid #0d6efd);
  border-left: var(--oi-tab-nav-hover-border-left, none);
  font: var(--oi-tab-nav-hover-font, bold 1.1rem arial, sans-serif);
  color: var(--oi-tab-nav-hover-color);
}
.tabs .panes {
  padding: var(--oi-tab-nav-panes-padding, 1rem);
}
.tabs .panes .pane {
  display: none;
}
.tabs .panes .pane.active {
  display: block;
}
.tabs .panes oi-loading {
  width: var(--oi-tab-loading-size, 3rem);
  height: var(--oi-tab-loading-size, 3rem);
  display: block;
  margin: auto;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiRDpcXOmhueebrlxcT01JSVxcdWlcXHNyY1xcdGFiIiwic291cmNlcyI6WyJpbmRleC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVRO0VBQ0k7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUVBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDSTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBSUo7RUFDSTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBS1o7RUFDSTs7QUFFQTtFQUNJOztBQUVBO0VBQ0k7O0FBSVI7RUFDSTtFQUNBO0VBQ0E7RUFDQSJ9 */`;
